import { render, staticRenderFns } from "./FormResult.vue?vue&type=template&id=2e1eb386&scoped=true"
import script from "./FormResult.ts?vue&type=script&lang=ts&external"
export * from "./FormResult.ts?vue&type=script&lang=ts&external"
import style0 from "./FormResult.vue?vue&type=style&index=0&id=2e1eb386&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1eb386",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e1eb386')) {
      api.createRecord('2e1eb386', component.options)
    } else {
      api.reload('2e1eb386', component.options)
    }
    module.hot.accept("./FormResult.vue?vue&type=template&id=2e1eb386&scoped=true", function () {
      api.rerender('2e1eb386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/LOPD/components/FormResult/FormResult.vue"
export default component.exports